export default "__VITE_ASSET__53645a01__"